export default "__VITE_ASSET__cZMDuzRW__"